module.exports = __webpack_public_path__ + "static/media/baal.74179dd1.png";